<div class="photo-container">
  <img [src]="data.url" alt="Image" width="100%" #imageElement />
  <button
    matTooltip="{{ 'NGX-MESSAGING.download' | translate }}"
    color="primary"
    class="photo-container__download"
    [matMenuTriggerFor]="menuDownload"
    mat-icon-button>
    <mat-icon class="photo-container__download-icon" svgIcon="download"></mat-icon>
  </button>

  <mat-menu #menuDownload>
    @for (type of imageTypes; track type) {
    <button mat-menu-item (click)="download(type)">{{ 'NGX-MESSAGING.download_as' | translate }} {{ type.type }}</button>
    }
  </mat-menu>
</div>
